export const messages = {
    'en': {
        'app.home': 'Home',
        'app.login': 'Login',
        'app.singup': 'Sing Up',
        'app.logout': 'Log Out',
    },
    'es': {
        'app.home': 'Inicio',
        'app.login': 'Ingresar',
        'app.singup': 'Registrarse',
        'app.logout': 'Salir',
    },
    'de': {
        'app.home': 'Rfajsdkfaj',
        'app.login': 'Rfajsdkfaj',
        'app.singup': 'Registrarse',
        'app.logout': 'Registrarse',
    },
};
